import { AdminConfiguration } from "./infecto-lms-admin/config";

export const ADMIN_CONFIG_IMPL: AdminConfiguration = {
	brandId: "QnJhbmQ6QnJhbmQ6ZTNiMTNlYzktNzZjMC00YTUyLWJkNDAtZjIxYWViMTU3MzJj",
};
